import { Box, Stack, Text } from '@mantine/core'
import React from 'react'

import styles from './style.module.css'

type MetricItemProps = {
  label: string
  value: string | number | React.ReactNode
  labelColor?: string
  subValue?: string | React.ReactNode
  showInline?: boolean
  hideBorder?: boolean
  isMobile?: boolean
  isFearGreed?: boolean
}

export default function MetricItem({
  label,
  value,
  subValue,
  labelColor = 'var(--text-secondary)',
  showInline = false,
  hideBorder = false,
  isMobile = false,
  isFearGreed = false,
}: MetricItemProps) {
  if (isMobile) {
    return (
      <Stack w={'100%'} h={'100%'} gap={4}>
        <Text variant="micro-text" c={labelColor} fw={500}>
          {label}
        </Text>
        {!isFearGreed ? (
          <Stack align="flex-start" gap={0}>
            <Text variant="body-emphasis">{value}</Text>
            {subValue && subValue}
          </Stack>
        ) : (
          value
        )}
      </Stack>
    )
  }

  if (showInline) {
    return (
      <Box className={hideBorder ? '' : styles.item}>
        <Text variant="body-emphasis" c={labelColor}>
          {label} {value} &nbsp;
          {subValue && subValue}
        </Text>
      </Box>
    )
  }

  return (
    <Box className={hideBorder ? '' : styles.item}>
      <Text
        variant="subtitle-emphasis"
        c="var(--text-secondary)"
        mb={typeof value === 'string' || typeof value === 'number' ? 4 : 0}
      >
        {label}
      </Text>
      {typeof value === 'string' || typeof value === 'number' ? (
        <Text variant="body-emphasis">{value}</Text>
      ) : (
        value
      )}
    </Box>
  )
}
